module.exports = __webpack_public_path__ + "img/dialog-close-icon.f7671975.svg";